import getPageTitle from "lib/utils/getPageTitle";
import type { ReactNode, HTMLAttributes } from "react";
import { Helmet as Head } from "react-helmet-async";
import cx from "ui/cx";
import styles from "./Page.module.scss";

export interface PageProps extends HTMLAttributes<HTMLDivElement> {
  pageTitle: string;
  children: ReactNode;
  loading?: boolean;
}

export default function Page({ pageTitle, loading, children, className }: PageProps) {
  return (
    <div className={cx(styles.wrapper, className)} data-testid="page-wrapper">
      <Head>
        <title>{getPageTitle(pageTitle)}</title>
        <meta name="robots" content="noindex" />
      </Head>
      {!loading ? children : null}
    </div>
  );
}
